export default {
    startBooking:{
        en:'Start Booking',
        tc:'開始預訂',
        sc:'开始预订'
    },
    searchAva:{
        en:'Search Availability',
        tc:'搜尋日期',
        sc:'搜索日期'
    },
    roomRate:{
        en:'Room & Rates',
        tc:'房間與價格',
        sc:'房间与价格'
    },
    guestInfo:{
        en:'Guest Information',
        tc:'客人資訊',
        sc:'客人信息'
    },
    success:{
        en:'Booking Success',
        tc:'預訂成功',
        sc:'预订成功'
    },
    checkAva:{
        en:'Check Availability',
        tc:'搜尋房間',
        sc:'搜索房间'
    },
    capacity:{
        en:'Capacity',
        tc:'可容納',
        sc:'可容纳'
    },
    roomSize:{
        en:'Room size',
        tc:'房間大小',
        sc:'房间大小'
    },
    bedSize:{
        en:'Bed size',
        tc:'床型',
        sc:'床型'
    },
    nights:{
        en:'NIGHTS',
        tc:'晚',
        sc:'晚'
    },
    room:{
        en:'room',
        tc:'房間',
        sc:'房间'
    },
    rooms:{
        en:'Rooms',
        tc:'房間',
        sc:'房间'
    },
    addARoom:{
        en:'Add a room',
        tc:'添加房間',
        sc:'添加房间'
    },
    select:{
        en:'Select',
        tc:'選擇',
        sc:'选择'
    },
    selected:{
        en:'Selected',
        tc:'已選擇',
        sc:'已选择'
    },
    checkIn:{
        en:'CHECK IN',
        tc:'入住時間',
        sc:'入住时间'
    },
    checkOut:{
        en:'CHECK OUT',
        tc:'退房時間',
        sc:'退房时间'
    },
    search:{
        en:'Search',
        tc:'搜尋',
        sc:'搜索'
    },
    selected:{
        en:'Selected',
        tc:'已選擇',
        sc:'已选择'
    },
    remove:{
        en:'remove',
        tc:'移除',
        sc:'移除'
    },
    total:{
        en:'Total',
        tc:'總計',
        sc:'总计'
    },
    tax:{
        en:'includes tax',
        tc:'已含稅',
        sc:'已含税'
    },
    open:{
        en:'Open',
        tc:'打開',
        sc:'打开'
    },
    collapse:{
        en:'Collapse',
        tc:'收起',
        sc:'收起'
    },
    continueToGuest:{
        en:'Continue to Guest Information',
        tc:'繼續填寫客人資訊',
        sc:'继续填写客人信息'
    },
    notes:{
        en:'NOTES',
        tc:'備註',
        sc:'备注'
    },
    notes_1:{
        en:'Other Available Amenities',
        tc:'其他可用設施',
        sc:'其他可用设施'
    },
    notes_2:{
        en:'Tooth Brushes / Razors / Basic Cosmetics / Adaptor Plugs / Smart Phone Chargers / Umbrellas',
        tc:'牙刷 / 剃鬚刀 / 基本化妝品 / 轉換插頭 / 智能手機充電器 / 雨傘',
        sc:'牙刷 / 剃须刀 / 基本化妆品 / 转换插头 / 智能手机充电器 / 雨伞'
    },
    notes_3:{
        en:'Shared Amenities',
        tc:'共享設施',
        sc:'共享设施'
    },
    notes_4:{
        en:'* All rooms are non-smoking.',
        tc:'* 所有房間均為禁煙房。',
        sc:'* 所有房间均为禁烟房。'
    },
    notes_5:{
        en:'* There are no in-room telephones.',
        tc:'* 房間內沒有電話。',
        sc:'* 房间内没有电话。'
    },
    //PAGE 3
    totalOccu:{
        en:'TOTAL OCCUPANCY',
        tc:'總入住人數',
        sc:'总入住人数'
    },
    person:{
        en:'person',
        tc:'人',
        sc:'人'
    },
    personStaying:{
        en:'How many person will be staying?',
        tc:'有多少人會入住？',
        sc:'有多少人会入住？'
    },
    guestInfomation:{
        en:'Guest Information',
        tc:'客人資訊',
        sc:'客人信息'
    },
    firstName:{
        en:'FIRST NAME',
        tc:'名字',
        sc:'名字'
    },
    lastName:{
        en:'FIRST NAME',
        tc:'姓氏',
        sc:'姓氏'
    },
    email:{
        en:'EMAIL ADRESS',
        tc:'電郵',
        sc:'电子邮件'
    },
    country:{
        en:'COUNTRY',
        tc:'國家',
        sc:'国家'
    },
    origin:{
        en:'Please select your country of origins.',
        tc:'請選擇您的國籍。',
        sc:'请选择您的国籍。'
    },
    phone:{
        en:'PHONE NUMBER',
        tc:'電話號碼',
        sc:'电话号码'
    },
    address:{
        en:'ADDRESS',
        tc:'地址',
        sc:'地址'
    },
    postal:{
        en:'POSTAL CODE',
        tc:'郵政編碼',
        sc:'邮政编码'
    },
    readCare:{
        en:'Please Read Carefully and Agree to Our Cancellation & Hotel Policies',
        tc:'請仔細閱讀並同意我們的取消政策和酒店政策',
        sc:'请仔细阅读并同意我们的取消政策和酒店政策'
    },
    tcApply:{
        en:'Terms and conditions apply',
        tc:'條款及細則適用',
        sc:'条款及细则适用'
    },
    haveRead:{
        en:'I have Read and Agree to the Terms and Conditions.',
        tc:'我已閱讀並同意條款及細則。',
        sc:'我已阅读并同意条款及细则。'
    },
    confirmBooking:{
        en:'Confirm Booking & Payment',
        tc:'確認預訂及付款',
        sc:'确认预订及付款'
    },
    confirm:{
        en:'Confirm',
        tc:'確認',
        sc:'确认'
    },
    Booking:{
        en:'Booking Number',
        tc:'預訂編號',
        sc:'预订编号'
    }
}